import { Component } from '@angular/core';

@Component({
    selector: 'footer-widget',
    standalone: true,
    template: `
        <footer class="py-6 px-6 md:px-12 lg:px-20 text-sm text-color-secondary">
            <div class="flex flex-col md:flex-row justify-between gap-4">
                <div>
                    © 2026 Workflow Automation Platform
                </div>
                <div>
                    Built for reliability. Not AI hype.
                </div>
            </div>
        </footer>
    `
})
export class FooterWidget {}
